import { Component, OnInit } from "@angular/core";
import { AbstractControl, FormGroup } from "@angular/forms";
import { FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';

import { ConfigService } from 'src/app/services/config/config.service';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';
import { Platform, ModalController, NavParams } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { LogoutService } from "src/app/services/logout/logout.service";

@Component({
    selector: 'page-pinlogin',
    templateUrl: 'pin-login.html'
})
export class PinLoginComponent implements OnInit {

    public error = null;
    public pinNumber: AbstractControl;
    public pinLoginForm: FormGroup;
    public responsibleGamingNumber: string;
    public didResendPin: boolean = false;
    public didResendPinFail: boolean = false;
    public showForm:boolean = true;
    constructor(
        protected navParams: NavParams,
        protected config: ConfigService,
        protected userSession: UserSessionService,
        protected authProvider: AuthenticationService,
        protected modal: ModalController,
        public events: EventsService,
        protected uniqueIDProvider: UniqueIDService,
        public successMessageService: SuccessMessageService,
        public responsibleProvider: AuthenticationService,
        public platform: Platform,
        protected appLinks: AppLinksService,
        private navigator: Navigator,
        private logoutService: LogoutService
    ) {

    }
    
    ngOnInit() {
        this.successMessageService.clearMessage();
        this.responsibleGamingNumber = this.config.getConfig().RESPONSIBLE_GAMING_NUMBER || '1-800-522-4700';

        this.pinLoginForm = new FormGroup({
            pinNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(4), Validators.maxLength(4)]),
        });

        this.pinNumber = this.pinLoginForm.get('pinNumber');
    }

    doPINLogin() {
        this.successMessageService.clearMessage();
        this.error = null;
        let customerId = this.navParams.get('customerId');
        let data = this.pinLoginForm.value;
        data.customerId = customerId;
        this.authProvider.callPin(data).subscribe(
            (response) => {
                localStorage.setItem('strongAuthenticationRequired', 'false');
                const callBackFn = this.navParams.get('callBackFn');
                if (callBackFn) {
                    this.navigator.dismiss();
                    callBackFn();
                } else {
                    this.navigator.dismiss();
                }
            },
            (error) => {
                switch (error.getErrorCode().toUpperCase()) {
                    case 'INVALID_PIN_NUMBER':
                        error.setErrorMessage('PIN does not match.');
                        break;
                    case 'MAX_PINNUMBER_ATTEMPTS_REACHED':
                        error.setErrorMessage(error.getErrorMessage());
                        this.showForm = false;
                        break;
                    default:
                        this.showForm = true;
                        error.setErrorMessage('An error has occured logging you in. Please try again.');
                        break;
                }
                this.error = error;
            }
        )
    }

    resendPin() {
        this.successMessageService.clearMessage();
        this.error = null;
        let customerId = this.navParams.get('customerId')
        //call service here when it is available.
        this.authProvider.callResendPinStrongAuth(customerId).subscribe(
            (response) => {
                // this.logger.log('onResendPIN response = ', response);
                if (response.result == 1) {
                    this.successMessageService.setMessage("We have sent your Personal Identification Number (PIN) to your email address.");
                }
            },
            (error) => {
                // this.logger.log('onResendPIN error = ', error);

                error.setErrorMessage('There was an issue trying to send your Personal Identification Number (PIN) to your email address. Please contact customer support.');
                this.error = error;
            }
        );
        return false;
    }

    closeModal = () => {
        return this.logoutService.onLogout({ reason: 'PLAYER_PIN_EXIT' });
    }
}
